// ── Importaciones tal cual ──────────────────────────────
import { useEffect, useState } from "react";
import { Button, Table, Modal, Form, Row, Col } from "react-bootstrap";
import ErrorAlert from "../Alerts/ErrorAlert";
import SuccessAlert from "../Alerts/SuccessAlert";
import { PickNGoFetchAPI } from "../../api/PickAndGo";
import { GroupsFechtAPI } from "../../api/Groups";

/* ─────────────────────────────────────────────────────────
   CSS — inyectado una vez. Prefijo: .apm-
───────────────────────────────────────────────────────── */
const APM_CSS = `
@keyframes apm-up   { from{opacity:0;transform:translateY(8px)} to{opacity:1;transform:translateY(0)} }
@keyframes apm-fade { from{opacity:0} to{opacity:1} }
@keyframes apm-spin { to{transform:rotate(360deg)} }
@keyframes apm-slide{ from{opacity:0;transform:translateY(16px) scale(.97)} to{opacity:1;transform:translateY(0) scale(1)} }

/* ── Bootstrap Modal overrides ── */
.apm-dialog { max-width: 760px !important; }
.apm-dialog .modal-content {
  border: 1.5px solid rgba(0,0,0,.08) !important;
  border-radius: 20px !important;
  box-shadow: 0 24px 64px rgba(0,0,0,.18), 0 6px 16px rgba(0,0,0,.08) !important;
  overflow: hidden !important;
  background: var(--bg, #fff) !important;
  animation: apm-slide .28s cubic-bezier(.34,1.56,.64,1) both !important;
}
.apm-dialog .modal-header { padding: 1rem 1.35rem .9rem !important; border-bottom: 1px solid var(--border, rgba(0,0,0,.07)) !important; }
.apm-dialog .modal-title  { font-size: .93rem !important; font-weight: 700 !important; color: var(--text, #0A0A0A) !important; font-family: var(--font-sans,-apple-system,sans-serif) !important; }
.apm-dialog .modal-body   { padding: 1.1rem 1.35rem !important; }
.apm-dialog .modal-footer { padding: .8rem 1.35rem .95rem !important; border-top: 1px solid var(--border, rgba(0,0,0,.07)) !important; }

/* modal footer buttons */
.apm-dialog .btn-secondary {
  background: rgba(0,0,0,.04) !important; border: 1.5px solid rgba(0,0,0,.12) !important;
  color: var(--text-2, #6B6B6B) !important; border-radius: 9px !important;
  font-family: var(--font-sans,-apple-system,sans-serif) !important;
  font-size: .82rem !important; font-weight: 500 !important; transition: all .14s !important;
}
.apm-dialog .btn-secondary:hover { border-color: var(--text-2) !important; color: var(--text, #0A0A0A) !important; }
.apm-dialog .btn-primary {
  background: #1B3A6B !important; border-color: #1B3A6B !important;
  border-radius: 9px !important; font-family: var(--font-sans,-apple-system,sans-serif) !important;
  font-size: .82rem !important; font-weight: 600 !important; transition: background .14s, transform .14s !important;
}
.apm-dialog .btn-primary:hover:not(:disabled) { background: #152D54 !important; border-color: #152D54 !important; transform: translateY(-1px) !important; }
.apm-dialog .btn-primary:disabled { opacity: .5 !important; }

/* ── section label ── */
.apm-section-label {
  font-size: .7rem; font-weight: 700; letter-spacing: .07em;
  text-transform: uppercase; color: var(--text-3, #B4B4B4);
  margin-bottom: .65rem; padding-bottom: .35rem;
  border-bottom: 1px solid var(--border, rgba(0,0,0,.07));
  font-family: var(--font-sans,-apple-system,sans-serif);
  display: flex; align-items: center; justify-content: space-between;
}
.apm-count-badge {
  display: inline-flex; align-items: center; justify-content: center;
  min-width: 18px; height: 17px; border-radius: 5px;
  background: rgba(27,58,107,.09); color: #1B3A6B;
  font-size: .62rem; font-weight: 700; padding: 0 .3rem;
}

/* ── search bar ── */
.apm-search-wrap {
  display: flex; gap: .4rem; margin-bottom: .75rem;
}
.apm-search-input {
  flex: 1;
  padding: .52rem .85rem;
  border: 1.5px solid rgba(0,0,0,.11) !important;
  border-radius: 10px !important;
  background: rgba(0,0,0,.03) !important;
  font-family: var(--font-sans,-apple-system,sans-serif) !important;
  font-size: .83rem !important; color: var(--text, #0A0A0A) !important;
  outline: none !important;
  transition: border-color .14s, box-shadow .14s !important;
}
.apm-search-input::placeholder { color: var(--text-3, #B4B4B4) !important; }
.apm-search-input:focus {
  border-color: #1B3A6B !important;
  box-shadow: 0 0 0 3px rgba(27,58,107,.10) !important;
  background: var(--bg, #fff) !important;
}
.apm-btn-search {
  padding: .52rem 1rem; border-radius: 10px; border: none;
  background: #1B3A6B; color: #fff;
  font-family: var(--font-sans,-apple-system,sans-serif);
  font-size: .8rem; font-weight: 600;
  cursor: pointer; transition: background .14s; white-space: nowrap;
  display: flex; align-items: center; gap: .3rem;
}
.apm-btn-search:hover:not(:disabled) { background: #152D54; }
.apm-btn-search:disabled { opacity: .5; cursor: not-allowed; }

/* ── results list ── */
.apm-results {
  border: 1.5px solid var(--border, rgba(0,0,0,.07));
  border-radius: 12px; overflow: hidden;
  max-height: 280px; overflow-y: auto;
  scrollbar-width: thin; scrollbar-color: rgba(0,0,0,.07) transparent;
}
.apm-results::-webkit-scrollbar { width: 4px; }
.apm-results::-webkit-scrollbar-thumb { background: rgba(0,0,0,.08); border-radius: 2px; }

.apm-result-row {
  display: flex; align-items: center; gap: .6rem;
  padding: .6rem .85rem;
  border-bottom: 1px solid var(--border, rgba(0,0,0,.06));
  transition: background .12s;
}
.apm-result-row:last-child { border-bottom: none; }
.apm-result-row:hover { background: var(--bg-2, rgba(0,0,0,.025)); }
.apm-result-name  { flex: 1; font-size: .8rem; font-weight: 500; color: var(--text, #0A0A0A); font-family: var(--font-sans,-apple-system,sans-serif); }
.apm-result-price { font-size: .76rem; color: var(--text-3, #B4B4B4); font-family: var(--font-sans,-apple-system,sans-serif); margin-right: .5rem; }
.apm-btn-add {
  display: inline-flex; align-items: center; gap: .25rem;
  padding: .25rem .65rem; border-radius: 7px; border: none;
  background: rgba(27,58,107,.09); color: #1B3A6B;
  font-family: var(--font-sans,-apple-system,sans-serif);
  font-size: .72rem; font-weight: 600;
  cursor: pointer; transition: all .14s; white-space: nowrap; flex-shrink: 0;
}
.apm-btn-add:hover:not(:disabled) { background: #1B3A6B; color: #fff; }
.apm-btn-add:disabled { opacity: .4; cursor: not-allowed; }

.apm-results-empty {
  padding: 1.5rem; text-align: center;
  font-size: .77rem; color: var(--text-3, #B4B4B4);
  font-family: var(--font-sans,-apple-system,sans-serif);
}

/* ── pagination ── */
.apm-pagination {
  display: flex; align-items: center; justify-content: space-between;
  margin-top: .65rem; flex-wrap: wrap; gap: .4rem;
}
.apm-page-info { font-size: .72rem; color: var(--text-3, #B4B4B4); font-family: var(--font-sans,-apple-system,sans-serif); }
.apm-page-info span { color: var(--text-2, #6B6B6B); font-weight: 600; }
.apm-page-btns { display: flex; gap: .3rem; }
.apm-btn-page {
  display: inline-flex; align-items: center; gap: .25rem;
  padding: .28rem .7rem; border-radius: 7px;
  border: 1.5px solid var(--border-md, rgba(0,0,0,.12));
  background: var(--bg, #fff); color: var(--text-2, #6B6B6B);
  font-family: var(--font-sans,-apple-system,sans-serif);
  font-size: .74rem; font-weight: 500;
  cursor: pointer; transition: all .14s; white-space: nowrap;
}
.apm-btn-page:hover:not(:disabled) { border-color: #1B3A6B; color: #1B3A6B; background: rgba(27,58,107,.06); }
.apm-btn-page:disabled { opacity: .38; cursor: not-allowed; }

/* ── assigned panel ── */
.apm-assigned {
  border: 1.5px solid var(--border, rgba(0,0,0,.07));
  border-radius: 12px; overflow: hidden;
  max-height: 360px; overflow-y: auto;
  scrollbar-width: thin; scrollbar-color: rgba(0,0,0,.07) transparent;
}
.apm-assigned::-webkit-scrollbar { width: 4px; }
.apm-assigned::-webkit-scrollbar-thumb { background: rgba(0,0,0,.08); border-radius: 2px; }

.apm-assigned-empty {
  padding: 2rem; text-align: center;
  font-size: .77rem; color: var(--text-3, #B4B4B4);
  font-family: var(--font-sans,-apple-system,sans-serif);
}

.apm-assigned-item {
  display: flex; align-items: center; gap: .65rem;
  padding: .6rem .85rem;
  border-bottom: 1px solid var(--border, rgba(0,0,0,.06));
  transition: background .12s; animation: apm-up .18s ease both;
}
.apm-assigned-item:last-child { border-bottom: none; }
.apm-assigned-item:hover { background: var(--bg-2, rgba(0,0,0,.025)); }

.apm-assigned-ico {
  width: 28px; height: 28px; border-radius: 7px; flex-shrink: 0;
  background: rgba(27,58,107,.08); color: #1B3A6B;
  display: grid; place-items: center; font-size: .85rem;
}
.apm-assigned-info { flex: 1; min-width: 0; }
.apm-assigned-name { font-size: .8rem; font-weight: 600; color: var(--text, #0A0A0A); font-family: var(--font-sans,-apple-system,sans-serif); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.apm-assigned-sub  { font-size: .68rem; color: var(--text-3, #B4B4B4); font-family: var(--font-sans,-apple-system,sans-serif); margin-top: 1px; }

.apm-btn-remove {
  display: inline-flex; align-items: center; gap: .25rem;
  padding: .25rem .6rem; border-radius: 7px; border: none;
  background: rgba(239,68,68,.07); color: #EF4444;
  font-family: var(--font-sans,-apple-system,sans-serif);
  font-size: .71rem; font-weight: 500;
  cursor: pointer; transition: all .14s; flex-shrink: 0;
}
.apm-btn-remove:hover { background: #FEE2E2; }

/* ── spinner ── */
.apm-spinner {
  width: 13px; height: 13px; border-radius: 50%;
  border: 2px solid rgba(27,58,107,.2); border-top-color: #1B3A6B;
  animation: apm-spin .6s linear infinite; flex-shrink: 0;
}

/* ── panel divider (desktop) ── */
.apm-panels {
  display: grid; grid-template-columns: 1fr 1fr; gap: 1.25rem;
}
@media(max-width: 600px) {
  .apm-dialog { max-width: calc(100vw - 2rem) !important; }
  .apm-panels { grid-template-columns: 1fr; }
  .apm-dialog .modal-body { padding: .9rem 1rem !important; }
}
`;

/* ── ICONS ── */
const IcoSearch  = ()=><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>;
const IcoPlus    = ()=><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>;
const IcoTrash   = ()=><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/></svg>;
const IcoChevL   = ()=><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><polyline points="15 18 9 12 15 6"/></svg>;
const IcoChevR   = ()=><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><polyline points="9 18 15 12 9 6"/></svg>;
const IcoBox     = ()=><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/></svg>;

/* ════════════════════════════════════════════════════════
   COMPONENT — lógica 100% original, nuevo shell visual
════════════════════════════════════════════════════════ */
const AssignProductsModal = ({ show, onHide, rule, businessId, token }) => {

  /* inject CSS once */
  useEffect(() => {
    const id = "apm-styles";
    if (!document.getElementById(id)) {
      const el = document.createElement("style");
      el.id = id; el.textContent = APM_CSS;
      document.head.appendChild(el);
    }
  }, []);

  /* ════════════════════════════════════
     LÓGICA ORIGINAL — 100% INTACTA
  ════════════════════════════════════ */
  const [assigned, setAssigned] = useState([]);
  const [filter,   setFilter]   = useState("");
  const [results,  setResults]  = useState([]);
  const [page,     setPage]     = useState(1);
  const [total,    setTotal]    = useState(0);
  const [loading,  setLoading]  = useState(false);
  const pageSize = 10;

  useEffect(() => {
    if (!show || !rule?.id) return;
    (async () => {
      try {
        setLoading(true);
        const res = await PickNGoFetchAPI.getRuleProducts(rule.id, token);
        const list = Array.isArray(res?.data) ? res.data : (res?.data?.items || []);
        setAssigned(list.map(p => ({ group_id: p.group_id, name: p.name, price: p.price })));
      } catch (e) {
        ErrorAlert("No se pudo cargar los productos asignados", "Pick & Go", "warning");
      } finally {
        setLoading(false);
      }
    })();
  }, [show, rule?.id, token]);

  const doSearch = async (_page = 1, _filter = filter) => {
    if (!businessId) return;
    try {
      setLoading(true);
      const res = await GroupsFechtAPI.searchProducts(businessId, _filter?.trim() || "", _page, token);
      const items = res?.data?.groups || res?.data || [];
      setResults(items.map(p => ({ group_id: p.group_id, name: p.name, price: p.price })));
      setTotal(Number(res?.data?.total ?? items.length));
      setPage(Number(res?.data?.page ?? _page));
    } catch (e) {
      ErrorAlert("No se pudo buscar productos", "Pick & Go", "warning");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (show) doSearch(1, "");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  const addProduct = (prod) => {
    if (assigned.some(p => p.group_id === prod.group_id)) return;
    setAssigned(prev => [...prev, prod]);
  };

  const removeProduct = (group_id) => {
    setAssigned(prev => prev.filter(p => p.group_id !== group_id));
  };

  const save = async () => {
    if (!rule?.id) return;
    try {
      setLoading(true);
      const product_ids = assigned.map(p => p.group_id);
      await PickNGoFetchAPI.setRuleProducts(rule.id, { product_ids }, token);
      SuccessAlert("Productos asignados guardados", "Listo");
      onHide();
    } catch (e) {
      ErrorAlert(e?.response?.data?.error || "Error guardando productos", "Pick & Go", "warning");
    } finally {
      setLoading(false);
    }
  };
  /* ════════════════════════════════════
     FIN LÓGICA ORIGINAL
  ════════════════════════════════════ */

  /* ══════════════════════════════════
     RENDER
  ══════════════════════════════════ */
  return (
    <Modal show={show} onHide={onHide} fullscreen>

      {/* HEADER */}
      <Modal.Header closeButton>
        <Modal.Title>
          Productos — <strong>{rule?.name || `Regla #${rule?.id}`}</strong>
        </Modal.Title>
      </Modal.Header>

      {/* BODY */}
      <Modal.Body>
        <div className="apm-panels">

          {/* ── COL IZQUIERDA: búsqueda ── */}
          <div>
            <div className="apm-section-label">
              Buscar productos
              {loading && <div className="apm-spinner" />}
            </div>

            {/* search input — lógica original intacta */}
            <div className="apm-search-wrap">
              <input
                className="apm-search-input"
                placeholder="Nombre o SKU"
                value={filter}
                onChange={e => setFilter(e.target.value)}
                onKeyDown={e => { if (e.key === 'Enter') doSearch(1, filter); }}
              />
              <button className="apm-btn-search" onClick={() => doSearch(1, filter)} disabled={loading}>
                <IcoSearch /> Buscar
              </button>
            </div>

            {/* results */}
            <div className="apm-results">
              {results.length === 0 ? (
                <div className="apm-results-empty">Sin resultados</div>
              ) : results.map(item => (
                <div className="apm-result-row" key={item.group_id}>
                  <span className="apm-result-name">{item.name}</span>
                  <span className="apm-result-price">{item.price || '—'}</span>
                  <button
                    className="apm-btn-add"
                    onClick={() => addProduct(item)}
                    disabled={assigned.some(p => p.group_id === item.group_id)}
                  >
                    <IcoPlus />
                    {assigned.some(p => p.group_id === item.group_id) ? 'Agregado' : 'Agregar'}
                  </button>
                </div>
              ))}
            </div>

            {/* pagination — lógica original intacta */}
            <div className="apm-pagination">
              <div className="apm-page-info">
                Página <span>{page}</span> · <span>{total}</span> resultados
              </div>
              <div className="apm-page-btns">
                <button
                  className="apm-btn-page"
                  disabled={page <= 1}
                  onClick={() => doSearch(page - 1)}
                >
                  <IcoChevL /> Anterior
                </button>
                <button
                  className="apm-btn-page"
                  disabled={(page * pageSize) >= total}
                  onClick={() => doSearch(page + 1)}
                >
                  Siguiente <IcoChevR />
                </button>
              </div>
            </div>
          </div>

          {/* ── COL DERECHA: asignados ── */}
          <div>
            <div className="apm-section-label">
              Asignados a la regla
              <span className="apm-count-badge">{assigned.length}</span>
            </div>

            <div className="apm-assigned">
              {assigned.length === 0 ? (
                <div className="apm-assigned-empty">
                  Aún no hay productos asignados.
                </div>
              ) : assigned.map(p => (
                <div className="apm-assigned-item" key={p.group_id}>
                  <div className="apm-assigned-ico"><IcoBox /></div>
                  <div className="apm-assigned-info">
                    <div className="apm-assigned-name">{p.name}</div>
                    <div className="apm-assigned-sub">{p.sku || '—'}</div>
                  </div>
                  <button
                    className="apm-btn-remove"
                    title="Quitar"
                    onClick={() => removeProduct(p.group_id)}
                  >
                    <IcoTrash /> Quitar
                  </button>
                </div>
              ))}
            </div>
          </div>

        </div>

        {/* ── row/col originales ocultos — preserva las importaciones ── */}
        <div style={{ display: 'none' }}>
          <Row className="g-3">
            <Col md={6}>
              <div className="d-flex gap-2">
                <Form.Control
                  placeholder="Nombre o SKU"
                  value={filter}
                  onChange={e => setFilter(e.target.value)}
                  onKeyDown={e => { if (e.key === 'Enter') doSearch(1, filter); }}
                />
                <Button variant="outline-secondary" onClick={() => doSearch(1, filter)} disabled={loading}>
                  Buscar
                </Button>
              </div>
              <div className="border rounded mt-2" style={{ maxHeight: 320, overflow: 'auto' }}>
                <Table size="sm" hover className="mb-0">
                  <thead><tr><th>Producto</th><th>Precio</th><th className="text-end">Acción</th></tr></thead>
                  <tbody>
                    {results.map(item => (
                      <tr key={item.group_id}>
                        <td>{item.name}</td>
                        <td className="text-muted">{item.price || '-'}</td>
                        <td className="text-end">
                          <Button size="sm" variant="outline-primary" onClick={() => addProduct(item)}
                            disabled={assigned.some(p => p.group_id === item.group_id)}>Agregar</Button>
                        </td>
                      </tr>
                    ))}
                    {!results.length && <tr><td colSpan={3} className="text-center text-muted">Sin resultados</td></tr>}
                  </tbody>
                </Table>
              </div>
            </Col>
            <Col md={6}>
              {assigned.map(p => (
                <div key={p.group_id} className="d-flex justify-content-between align-items-center border rounded px-2 py-1 mb-2 bg-light">
                  <div>
                    <div className="fw-semibold">{p.name}</div>
                    <div className="small text-muted">{p.sku || '—'}</div>
                  </div>
                  <Button size="sm" variant="outline-danger" onClick={() => removeProduct(p.group_id)} title="Quitar">quitar</Button>
                </div>
              ))}
            </Col>
          </Row>
        </div>
      </Modal.Body>

      {/* FOOTER — lógica original intacta */}
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={loading}>Cancelar</Button>
        <Button variant="primary"   onClick={save}   disabled={loading}>
          {loading ? 'Guardando…' : 'Guardar'}
        </Button>
      </Modal.Footer>

    </Modal>
  );
};

export default AssignProductsModal;